/**
 * Css class for hidden fields
 */
export const FIELD_HIDDEN_CLASS = 'dynamic-form__field_is_hidden';

/**
 * Css class for fullwidth fields
 */
export const FIELD_FULLWIDTH_CLASS = 'dynamic-form__field_is_fullwidth';
